import * as React from 'react';
const context = /*#__PURE__*/React.createContext({});
context.displayName = 'AccordionContext';
export default context;